export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Altes Passwort"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwortbestätigung"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"Neues Passwort\" und \"Passwortbestätigung\" stimmen nicht überein."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort ändern"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeichenfolge von 4 bis 63 Zeichen. Erlaubte Zeichen sind lateinische Buchstaben, Zahlen und Symbole"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leer"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schwach"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mittel"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stark"])}
  }
}